import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApplicantService } from '../../applicant/applicant.service';

@Component({
    selector: 'app-cf-status-display',
    templateUrl: './cf-status-display.component.html',
    styleUrls: ['./cf-status-display.component.scss'],
    imports: [CommonModule]
})
export class CfStatusDisplayComponent implements OnChanges {
    @Input() status!: string;

    private applicantService = inject(ApplicantService);

    stateClass!: {};
    stateName!: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["status"]) {
            this.stateName = this.applicantService.getStateDisplayName(this.status);
            this.stateClass = this.applicantService.getStateDisplayClass(this.status);
        }
    }
}
